import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button} from 'react-bootstrap';
import {getManeuverTypes} from "../actions/maneuverTypes";

export class ManeuverTypesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    // state
    list: PropTypes.array.isRequired,
    error: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    // action
    getManeuverTypes: PropTypes.func.isRequired,
  };

  async componentDidMount() {
    await this.load();
  }

  load = async() => {
    try {
      await this.props.getManeuverTypes();
    } catch (err) {
      // nothing to do, error message is in error prop
    }
  };

  addClick = () => {
    this.props.history.push('/maneuverTypes/add');
  };

  render() {
    const {list} = this.props;
    return <div>
      <h3>Maneuver Types / Traffic Options</h3>
      <Button onClick={this.addClick}>Add</Button>
      <table>
        <thead>
        <tr>
          <th>Maneuver</th>
          <th>Name</th>
        </tr>
        </thead>
        <tbody>
        {list.map(({maneuverTypeId, maneuverNames, name}) => (
          <tr key={maneuverTypeId}>
            <td>{maneuverNames.join(', ')}</td>
            <td>{name}</td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>;
  }
}

const mapStateToProps = state => ({
  ...state.maneuverTypes
});
const mapDispatchToProps = dispatch => bindActionCreators({
  getManeuverTypes,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ManeuverTypesPage);
